/* eslint-disable(prettier/prettier) */
// 🔴 DO NOT EDIT — This file is generated.

import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
const BookmarkSvg = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <mask
      id="a"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={-1}
      width={24}
      height={25}
    >
      <path fill="#D9D9D9" d="M0-.5h24v24H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        d="m12 16.962-3.97 1.703q-.903.387-1.716-.148-.814-.534-.814-1.503V4.808q0-.758.525-1.283T7.308 3h9.384q.758 0 1.283.525t.525 1.283v12.206q0 .969-.814 1.503-.813.535-1.717.148zm0-1.662 4.567 1.967q.154.067.293-.029a.3.3 0 0 0 .14-.26V4.809a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H7.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v12.17a.3.3 0 0 0 .14.26q.138.096.293.03z"
        fill="currentColor"
      />
    </g>
  </svg>
)
const ForwardRef = forwardRef(BookmarkSvg)
export default ForwardRef
